export const RequiredMark: React.FC = () => (
  <sup className="text-danger ms-1">*</sup>
);
